/**
 * DOM-owned React Flow target handle — anchored to its parent section
 * (`position: relative` + `top: 50%`), never positioned from the whole
 * Generate Video node shell.
 */

import { Handle, Position } from '@xyflow/react'

interface Props {
  id: string
  className?: string
  testId?: string
  hidden?: boolean
  /** VistoeraTASK-00342 — enables `:has(.pcv-dropzone-handle.connectingto.valid)`
   * slot highlight parity with Generate Image related-assets zone. */
  dropZoneHandle?: boolean
}

export default function VideoInputSectionHandle({
  id,
  className,
  testId,
  hidden,
  dropZoneHandle = true,
}: Props) {
  if (hidden) return null
  const handleClass = [
    className ?? 'pcv-handle pcv-handle--section-owned',
    dropZoneHandle ? 'pcv-dropzone-handle' : '',
  ]
    .filter(Boolean)
    .join(' ')
  return (
    <div className="pcv-video-input-section-handle-anchor" aria-hidden={hidden ? true : undefined}>
      <Handle
        type="target"
        position={Position.Left}
        id={id}
        className={handleClass}
        data-testid={testId}
      />
    </div>
  )
}
